import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';

function PionerosEnergiaList(props: any) {
  useEffect(() => {
    document.title = 'FG Pioneros Energía - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || '';
            return <span>{text ? `${text.substring(0, 100)}...` : 'Sin contenido'}</span>;
          }}
        />

        <FunctionField
          label="Detalle"
          render={(record: any) => {
            const text = record.detalle?.[0]?.children?.[0]?.text || '';
            return <span>{text ? `${text.substring(0, 100)}...` : 'Sin contenido'}</span>;
          }}
        />

        <FunctionField
          label="Slides Hero"
          render={(record: any) => {
            const total = Array.isArray(record.hero) ? record.hero.length : 0;
            return <span>{total}</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default PionerosEnergiaList;
